// extracted by mini-css-extract-plugin
export default {"bioContainer":"Pasadia_bioContainer__7uXe0","bioimg":"Pasadia_bioimg__ezTy-","bio":"Pasadia_bio__0cRPo","libro":"Pasadia_libro__P52ck","bioText":"Pasadia_bioText__tRvRw"};